import WithSidebar from 'Layout/WithSidebar';
import { relatedProductPageTitles } from 'components/NavigationSideBar/mockData';
import image from 'images/small-images-inside-text/wuxal.jpg';
import formulaImage from 'images/info-image-2.jpg';
import formulaImageMobile from 'images/formula-mobile.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItemsBox from 'components/ProductItemsBox';
import { products, tabsData, vegetables } from 'components/ProductItems/mockData';
import GeneralInfoBox from 'components/GeneralInfoBox';
import { Button } from 'components/buttons/Button/Button';
import BenefitsBox from 'components/BenefitsBox';
import NavigationSideBar from 'components/NavigationSideBar';
import { data2 } from 'components/BenefitsBox/mockData';
import ProductItemsBoxWithTabs from 'components/ProductItemsBox/ProductItemsBoxWithTabs';
import PictureComponent from 'components/PictureComponent';
import Banner from 'components/Banner';
import relatedProductBanner from 'images/relatedProductBanner.jpg';
import PDFBox from 'components/PDFBox';
import { relatedProductFiles } from 'components/PDFBox/mockData';
import React from 'react';
import { calculateActiveIndex } from 'components/NavigationSideBar/helpers';
import NavigationSectionWrapper from 'components/NavigationSideBar/NavigationSectionWrapper';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const RelatedProduct = () => {
    const [sectionsData, setSectionsData] = React.useState({});
    const [activeIndex, setActiveIndex] = React.useState(0);

    const pageContent = [
        <GeneralInfoBox>
            <h3>General information</h3>
            <p>
                Wuxal Р Мах is ideal for promoting the growth and development of the root system of plants in the early
                stages of vegetation, as well as for reducing plant stress caused by phosphorus or zinc deficiency.
            </p>
            <p>
                The phosphorus in Wuxal Р Мах is in the form of water-soluble phosphate, which guarantees fast and safe
                phosphorus supply to plants. It also contains nitrogen, which promotes plant growth.
            </p>
            <p>
                Wuxal Р Мах has the best buffering properties and neutralizes the pH of the working solution, which
                guarantees the optimal effect of plant protection products.
            </p>
            <p>
                Wuxal has been known on the Ukrainian market since 2003 and has gained a reputation as a high-quality,
                effective and reliable means of increasing crop productivity. The technologies implemented in Wuxal are
                one step ahead of modern cultivation technologies.
            </p>
            <Button type="read-more">READ MORE</Button>
        </GeneralInfoBox>,
        <PictureComponent srcBig={formulaImage} srcSmall={formulaImageMobile} alt="formula" />,
        <BenefitsBox title="Benefits" data={data2} />,
        <PDFBox title="Technical information" data={relatedProductFiles} />,
        <ProductItemsBoxWithTabs title="Trial results" data={tabsData} />,
        <ProductItemsBox title="Crop nutrition programs" data={vegetables} />,
        <ProductItemsBox title="Related products" data={products} />,
    ];

    const arrLength = pageContent.length;
    const [refs, setRefs] = React.useState([]);

    React.useEffect(() => {
        setRefs(refs =>
            Array(arrLength)
                .fill()
                .map((_, i) => refs[i] || React.createRef()),
        );
    }, [arrLength]);

    React.useEffect(() => {
        setActiveIndex(calculateActiveIndex(sectionsData));
    }, [sectionsData]);

    return (
        <>
            <Banner
                title="Our products"
                image={relatedProductBanner}
                buttonText="FIND A DISTRIBUTOR"
                buttonType="banner"
            />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>about product</LabelButton>
                        <GradientText>
                            Highly concentrated <br /> suspension of
                            <img src={image} alt="decor" />
                            <em>Wuxal P Max New</em>
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Highly concentrated suspension with a high content of phosphorus and zinc, which has
                                <em>
                                    the properties of a water conditioner, anti evaporation agent and viscous sludge
                                    reactor.
                                </em>
                            </GradientText>
                        </div>
                    </div>
                </div>

                <WithSidebar
                    Sidebar={
                        <NavigationSideBar activeIndex={activeIndex} refs={refs} items={relatedProductPageTitles} />
                    }
                >
                    {pageContent.map((item, index) => (
                        <div ref={refs[index]} key={index}>
                            <NavigationSectionWrapper index={index} setData={setSectionsData}>
                                {item}
                            </NavigationSectionWrapper>
                        </div>
                    ))}
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default RelatedProduct;
